@if (!isAuthenticated()) {
  <app-login />
} @else {
  <h1>Välkommen till Returappen!</h1>

  <div class="features-container">
    <a mat-flat-button routerLink="/book-shipment">Boka retur</a>
    <a [routerLink]="['/tracking/my-shipments']">Mina försändelser</a>

    @if(canViewHistory()) {
      <a routerLink="/tracking/history">Historik</a>
    }
  </div>
}
